import { getLoggedInUserInfo } from "./api_helper";

const ROLES_FOR_APP = {
  DASHBOARD_VIEW: "view",

  NAVER_KEYWORD_LIST: "naver_keyword",
  NAVER_KEYWORD_CREATE: "naver_keyword",
  NAVER_KEYWORD_UPDATE: "naver_keyword",
  NAVER_KEYWORD_DELETE: "naver_keyword",

  AGENCY_LIST: "agency_list",
  AGENCY_CREATE: "agency_create",
  AGENCY_UPDATE: "agency_update",
  AGENCY_DELETE: "agency_remove",

  PREPAYMENT_LIST: "prepayment_list",
  PREPAYMENT_CREATE: "prepayment_create",
  PREPAYMENT_UPDATE: "prepayment_update",
  PREPAYMENT_DELETE: "prepayment_remove",

  OPERATOR_LIST: "user_list",
  OPERATOR_CREATE: "user_create",
  OPERATOR_UPDATE: "user_update",
  OPERATOR_DELETE: "user_remove",

  USER_LIST: "sp_user_list",
  USER_CREATE: "sp_user_create",
  USER_UPDATE: "sp_user_update",
  USER_DELETE: "sp_user_remove",

  KEYWORD_BOOST_LIST: "keyword_boost_list",
  KEYWORD_BOOST_CREATE: "keyword_boost_create",
  KEYWORD_BOOST_UPDATE: "keyword_boost_update",
  KEYWORD_BOOST_DELETE: "keyword_boost_remove",

  REDEEM_CODE_LIST: "redeem_code_list",
  REDEEM_CODE_CREATE: "redeem_code_create",
  REDEEM_CODE_UPDATE: "redeem_code_update",
  REDEEM_CODE_DELETE: "redeem_code_remove",

  ADMIN_ACTIVITY_LOGS: 'user_list', // 
};

const isHavePermissionRole = (keyRoles: string | string[], permissions: string = "admin"): boolean => {
  const roles = typeof keyRoles === 'string' ? [keyRoles] : keyRoles;
  const data = getLoggedInUserInfo();
  if(data?.user?.role === 'admin') return true;
  
  return [ROLES_FOR_APP.PREPAYMENT_LIST, ROLES_FOR_APP.USER_LIST]?.some(item => roles?.includes(item));
};

export { ROLES_FOR_APP, isHavePermissionRole };